import type { CategoryType } from "mws-ts-v2-sdk";

type FilterOption = {
  label: string;
  value: string;
};

type EventFilterOptions = {
  [k: string]: FilterOption[];
};

export const getAppliedCategoryFilterTypes = (
  filterCategories: EventFilterOptions,
  appliedFilterIds: string[],
) => {
  const appliedFilterTypes = new Set<string>();

  Object.keys(filterCategories).forEach((key) => {
    filterCategories[key]?.forEach((option) => {
      if (appliedFilterIds?.includes(option.value)) {
        appliedFilterTypes.add(key);
      }
    });
  });

  return [...appliedFilterTypes];
};

export const getAppliedFilterTypesCategoryPage = (
  filterCategories: string[],
  categoryFilterOptions: {
    categoryType: CategoryType;
    options: FilterOption[];
  }[],
) => {
  const appliedFilterTypesSet = new Set<string>();

  filterCategories.forEach((filter) =>
    categoryFilterOptions.forEach((option) => {
      const foundOption = option.options.find((opt) => opt.value === filter);
      if (foundOption) {
        appliedFilterTypesSet.add(option.categoryType);
      }
    }),
  );

  return [...appliedFilterTypesSet];
};
